import { useSyncExternalStore } from "react";
import type { ReportCategory } from "@hermes/shared";
import type { Chat } from "../api/types";

/** `index` — список разделов (на телефоне); на широком экране вместо него открыто «Оформление». */
export type SettingsTab = "index" | "appearance" | "notifications" | "memory" | "vocabulary" | "keys" | "account" | "about";
export type ChatAction = { type: "rename" | "delete" | "tags"; chat: Chat };

/**
 * Форма «Сообщить об ошибке»; error — текст ошибки, из-за которой её открыли (уйдёт в контекст обращения);
 * text и category — заготовка обращения (например, просьба о приглашении в TestFlight со страницы «Приложения»).
 */
export type ReportOpen = { error?: string; text?: string; category?: ReportCategory };

/** Окна поверх чата: палитра команд, настройки, переименование и удаление чата, форма обращения. Открываются из любого места. */
type Ui = { palette: boolean; settings: SettingsTab | null; chatAction: ChatAction | null; report: ReportOpen | null };

let ui: Ui = { palette: false, settings: null, chatAction: null, report: null };
const subs = new Set<() => void>();

export function setUi(patch: Partial<Ui>) {
  ui = { ...ui, ...patch };
  subs.forEach((f) => f());
}

export const openPalette = () => setUi({ palette: true });
export const openSettings = (tab: SettingsTab = "index") => setUi({ palette: false, settings: tab });
export const openReport = (r: ReportOpen = {}) => setUi({ palette: false, settings: null, report: r });
export const openChatAction = (a: ChatAction) => setUi({ palette: false, chatAction: a });

export function useUi(): Ui {
  return useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => ui,
  );
}
